export enum PPCPositionTypes {
  ABOVE_DESCRIPTION = 1,
  BELOW_DESCRIPTION = 2,
  BELOW_TECHNICAL_DETAILS = 3,
  BELOW_BUY_BUTTON = 4,
  ABOVE_BUY_BUTTON = 5,
}

export enum PPCPositionTypesUK {
  ABOVE_DESCRIPTION = 1,
  BELOW_DESCRIPTION = 2,
  BELOW_TECHNICAL_DETAILS = 3,
  DIGITAL_PARTNER_MESSAGING = 5,
  BELOW_BUY_BUTTON = 6,
  ABOVE_BUY_BUTTON = 7,
}

export type PPCPositionTypesByMarket = PPCPositionTypesUK | PPCPositionTypes;
